// extracted by mini-css-extract-plugin
export var backgroundFallBack = "CategoryListing-module--backgroundFallBack--6b013";
export var cardContainer = "CategoryListing-module--cardContainer--ef08b";
export var cardExtraClassName = "CategoryListing-module--cardExtraClassName--f6c55";
export var cardWidth = "CategoryListing-module--cardWidth--83d4e";
export var headercontainer = "CategoryListing-module--headercontainer--b75c1";